import type { z } from 'zod';
import { makeVaultValidatedRequest } from './make-vault-validated-request';

interface IVaultPostRequestParams<S extends z.ZodType> {
  path: string;
  body: unknown;
  schema: S;
  baseUrl?: string;
}

export async function vaultPostRequest<S extends z.ZodType>({
  path,
  body,
  schema,
  baseUrl,
}: IVaultPostRequestParams<S>): Promise<z.infer<S>> {
  return makeVaultValidatedRequest({ method: 'POST', path, body, schema, baseUrl });
}
